import {put, call} from 'redux-saga/effects';
import LoginActions from '../reducers/login/LoginRedux';


function* callServer(apiFunction, data, onSuccess, onError, showError = true) {
  const response = yield call(apiFunction, data, data.id);
  if (response.ok) {
    yield call(onSuccess, response.data);
  } else {
    let message = '';
    if (response.data) {
      if (response.data.Error) {
        message = response.data.Error;
      } else if (response.data.message) {
        message = response.data.message;
      } else if (response.data.error) {
        message = response.data.error;
      } else {
        message = getMessage(response.problem)
      }
    }  else {
      message = getMessage(response.problem)
    }
    if (showError) {
      //showMessage(message); If you want to show error from here
    }
    if (response.status === 401) {
      yield put(LoginActions.createLogoutSuccess());
    }
    yield call(onError, message, response.status);
  }
}

const getMessage = (error) => {
      if (error === 'TIMEOUT_ERROR') {
        return 'No Response From Server';
      } else if (error === 'CONNECTION_ERROR') {
        return 'Server Is Not Available'
      } else if (error === 'NETWORK_ERROR') {
        return 'Network not available'
      } else {
        return 'Something went wrong. Please try again'
      }
    }
;

export default {
  callServer
}
